module.exports = __webpack_public_path__ + "qr_code_ios_roc.e6c6eb5.png";